import _get from 'lodash/get';
// import _has from 'lodash/has'; // Removed because it's unused
import _isEmpty from 'lodash/isEmpty';

import { capitalize } from 'libs/strings';

import {
  MEDIA_CATEGORY_FOOD_AND_DRINK,
  MEDIA_CATEGORY_MENU,
  MEDIA_CATEGORY_PRODUCT,
  MULTIPLE_IMAGE_CATEGORIES,
} from '../../constants/media';
import { isBeautyCategory, isRestaurantCategory } from '../../services/gbp';

export function getInitialFormData(file, fileMetadata) {
  const { description: fileDescription = '' } = file || {};

  const metadata = _get(fileMetadata, 'metadata', {});
  const fileMetadataDescription = _get(metadata, 'description', '');
  const association = _get(metadata, 'locationAssociationCategory', '');

  return {
    description: fileMetadataDescription || fileDescription || '',
    association,
  };
}

export function getCategoryOptions(association, gmbLocation) {
  const isRestaurant = isRestaurantCategory(gmbLocation);
  const isBeauty = isBeautyCategory(gmbLocation);

  if (MULTIPLE_IMAGE_CATEGORIES.includes(association) || _isEmpty(association)) {
    return MULTIPLE_IMAGE_CATEGORIES.filter((category) => {
      const restriction = {
        [MEDIA_CATEGORY_FOOD_AND_DRINK]: isRestaurant,
        [MEDIA_CATEGORY_MENU]: isRestaurant,
        [MEDIA_CATEGORY_PRODUCT]: isRestaurant || isBeauty,
      }[category];

      return restriction !== false;
    }).map((category) => ({
      key: category,
      value: category,
      text: capitalize(category.replace(/_/g, ' ')),
    }));
  }

  return [
    {
      key: association,
      text: capitalize(association.replace(/_/g, ' ')),
      value: association,
    },
  ];
}
